import React from 'react';

/**
 * Development tool for determining why a component rendered.  Helpful for solving issues with components rerendering too often due to
 * some props or state changing too frequently.
 */
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV !== 'production') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  const ReactRedux = require('react-redux');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    trackExtraHooks: [[ReactRedux, 'useSelector']],
  });
}
